<template>
  <div class="flex flex-col justify-center gap-10 md:flex-row md:flex-wrap md:gap-8">
    <div class="te-graduate-block">
      <div class="h-full bg-white shadow">
        <slot name="image" />
        <div class="p-4">
          <div class="relative">
            <div class="mb-3 flex flex-wrap text-center">
              <div class="w-full bg-co-success-500 p-3 text-white">
                <p class="mb-1 font-bold">
                  <slot name="role" />
                </p>
                <p class="co-display-14 mb-0">
                  <slot name="company" />
                </p>
              </div>
            </div>
            <p class="co-display-10 mb-2 font-bold text-co-gray-700">
              <slot name="catch" />
            </p>
            <h4 class="co-display-12 mb-3">
              <slot name="name" />
            </h4>
            <p class="mb-0">
              <slot name="comment" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="te-graduate-block">
      <div class="h-full bg-white shadow">
        <slot name="image2" />
        <div class="p-4">
          <div class="relative">
            <div class="mb-3 flex flex-wrap text-center">
              <div class="w-full bg-co-success-500 p-3 text-white">
                <p class="mb-1 font-bold">
                  <slot name="role2" />
                </p>
                <p class="co-display-14 mb-0">
                  <slot name="company2" />
                </p>
              </div>
            </div>
            <p class="co-display-10 mb-2 font-bold text-co-gray-700">
              <slot name="catch2" />
            </p>
            <h4 class="co-display-12 mb-3">
              <slot name="name2" />
            </h4>
            <p class="mb-0">
              <slot name="comment2" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="te-graduate-block">
      <div class="h-full bg-white shadow">
        <slot name="image3" />
        <div class="p-4">
          <div class="relative">
            <div class="mb-3 flex flex-wrap text-center">
              <div class="w-full bg-co-success-500 p-3 text-white">
                <p class="mb-1 font-bold">
                  <slot name="role3" />
                </p>
                <p class="co-display-14 mb-0">
                  <slot name="company3" />
                </p>
              </div>
            </div>
            <p class="co-display-10 mb-2 font-bold text-co-gray-700">
              <slot name="catch3" />
            </p>
            <h4 class="co-display-12 mb-3">
              <slot name="name3" />
            </h4>
            <p class="mb-0">
              <slot name="comment3" />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.te-graduate-block {
  width: 100%;
}

@media (min-width: 768px) {
  .te-graduate-block {
    width: calc(50% - 1rem);
  }
}

@media (min-width: 992px) {
  .te-graduate-block {
    width: calc(33% - 2rem);
  }
}
</style>
